import React from 'react';
import  {IndexLink,Link} from 'react-router';
import * as commonApi from '../../../api/common-api';
import { connect } from 'react-redux';
import Loading from 'react-loading';
import axios from 'axios';
var querystring = require('querystring');
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ReactDOM from 'react-dom';
import Textarea from 'react-textarea-autosize';

//var termArr = [];
class ProfileGroup extends React.Component{
	constructor(props) {
    super(props);
    
    var d = new Date();
	var y = d.getFullYear();
	var dateOptions = this.generateOptions(2010,y);
	var mOps = [
    { value: 'Jan', label: 'Jan' },
    { value: 'Feb', label: 'Feb' },
    { value: 'Mar', label: 'Mar' },
    { value: 'Apr', label: 'Apr' },
    { value: 'May', label: 'May' },
    { value: 'Jun', label: 'Jun' },
    { value: 'Jul', label: 'Jul' },
    { value: 'Aug', label: 'Aug' },
    { value: 'Sep', label: 'Sep' },
    { value: 'Oct', label: 'Oct' },
    { value: 'Nov', label: 'Nov' },
    { value: 'Dec', label: 'Dec' }
];
var my=false;
if(this.props.user.id_account == this.props.profileId)
{
	my=true;
}
	this.state = {profileId:this.props.profileId,loading:false,my:my,orgArr:[],orgs:[],sgroupOps:[],show:false,mOps:mOps,dateOptions:dateOptions,item:{}};
    //profileId = this.props.profileId;
    //this.getCourses = this.getCourses.bind(this);
  }
  generateOptions(from,to){
  	var options = [];
  	for (var i = from; i <= to; i++)
  	{
  		options.push({ value: i.toString(), label: i.toString() });
  	}
	
  	return options.slice();
  }
  
getDateFromString(mon,year){
   		return new Date(Date.parse(mon +" 1, "+year));
	}
	monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months+1;
}

	componentDidMount() {
		this.setState({loading:true},()=>{this.getOrgs();});
			    axios.get(commonApi.getAPIURL()+'?api=getSgroups&user_id=' + this.state.profileId)
			    .then(response => {	
			    	if(response.data.status == 1)
			    	{
			    		var array = [];
		    		var i = 1;
		    		for(var item of response.data.data)
		    		{
		    			var name = item.name_sgroup ;
		    			
		    			var img = '';
		    			if(item.id_file_sgroup>0)
		    			{
		    				img = item.file.link_file;
		    			}
		    			var des = item.name_university;
		    			array.push({ value: item.id_sgroup, label: name,des:des, icon: img });
		    			i++;
		    		}
			    		this.setState({sgroupOps:array});
			    		//store.dispatch(getUserSuccess(response.data.data));
			    	}
			    	//console.log(response.data);
			      
			      return response;
			    });
			  
			
	}
	componentWillReceiveProps(nextProps) {
		var my=nextProps.my;
		
		var loading = false;
		if(nextProps.profileId!=this.props.profileId)
		{
			loading = true;
		}
		if(loading)
		{
			this.setState({loading:loading,profileId:nextProps.profileId,my:my,orgArr:[],orgs:[]},()=>{this.getOrgs();});
		}
		else {
			this.setState({profileId:nextProps.profileId,my:my});
		}
		
		
		
		//profileId = nextProps.profileId;
		//this.getCourses();
	}
	getOrgs()
	{
		
		axios.get(commonApi.getAPIURL()+'?api=getOrgs&user_id='+this.state.profileId)
			    .then(response => {	
			    	if(response.data.status == 1)
			    	{
			    		var orgArr = [];
			    		var i=0;
			    		for(var item of response.data.data)
			    		{
			    			
							
								var avatar = item.name.substring(0,1).toUpperCase();
								if(item.id_file > 0)
								{
									avatar = (<img src={item.file.link_file}/>);
								}
								var des = item.mstart + " " +item.start + " - " +item.mend + " "+item.end;
								if(item.current==1)
								{
									var des = item.mstart + " " +item.start + " - Present" ;
								}
								var style = {};
								if(i==0)
							{
								style = {border:"none"};
							}
								orgArr.push(<div key={"exp-item-"+item.id} className="item_box" style = {style}>
				<div className="left_item_box">
					<div className="image">	
						{avatar}
					</div>
				</div>
				<div className="right_item_box">
					<div className="title">{item.position} {item.current==1?(<div className="primary_tag">Current Position</div>):""}</div>
					<div className="des">{item.name} </div>
					
					
					<div className="des">{des}</div>
					<div className="des2">{item.des}</div>
					
					
					{this.state.my?(<div><a onClick={this.removeOrg.bind(this,item)}  className="close_btn"><img src="/static/img/appimg/icon_close_x.png"/></a>
					<a onClick={this.editOrg.bind(this,item)} className="edit_btn"><img src="/static/img/appimg/email-icon03.png"/></a></div>):""}
				</div>
			</div>);
						i++;	
			    		}
			    		
			    		this.setState({orgs:response.data.data,orgArr:orgArr});
			    		//store.dispatch(getUserSuccess(response.data.data));
			    	}
			    	this.setState({loading:false});
			    	//console.log(response.data);
			      
			      return response;
			    });
	}
	
	
	
	optionRenderer(option)
   	{
   		var img = option.label.substring(0,1).toUpperCase();
   		if(option.icon!="")
   		{
   			img = (<img src={option.icon} />);
   		}
   		return (<div className="option_item">
   					<div className="option_img">
   						{img}
   					</div>
   					<div className="option_label">
   						<span className="name">{option.label}</span><br/>
   						<span className="des">{option.des}</span>
   					</div>
   				</div>);
   	}
   	
 
   	onSelectSgroup(item)
   	{
   		var it = this.state.item;
   		
   		it.sgroup=item.value;
   		this.setState({item:it});
   	}
   	onSelectMStart(item)
   	{
   		var it = this.state.item;
   		
   		it.mstart=item.value;
   		this.setState({item:it});
   	}
   	onSelectMEnd(item)
   	{
   		var it = this.state.item;
   		
   		it.mend=item.value;
   		this.setState({item:it});
   	}
   	onSelectStart(item)
   	{
   		var it = this.state.item;
   		
   		it.start=item.value;
   		this.setState({item:it});
   	}
   	onSelectEnd(item)
   	{
   		var it = this.state.item;
   		
   		it.end=item.value;
   		this.setState({item:it});
   	}
   	handleTxtChange(event)
	{
		var it = this.state.item;
		it.des=event.target.value;
   		this.setState({item:it});
		
	}
	onCurrentClick(e){
   		var it = this.state.item;
   		if(it.current == undefined)
   		{
   			it.current = true;
   		}
   		else {
   			it.current = !it.current;
   		}
  		//var val = !this.state.paid;
  		this.setState({item:it});
  		
  	}
	onPositionChange(e)
  	{
  		var it = this.state.item;
		it.position=e.target.value;
   		this.setState({item:it});
  	}
   	
  	addClick(e)
  	{
  		this.setState({show:true,item:{}})
  	}
  	save(e)
  	{
  		var item = this.state.item;
  		if(item.position == undefined || item.position.trim().length == 0)
		{
			commonApi.showAlert("Please enter position");
			return;
			//return;
		}
  		if(item.sgroup == undefined)
		{
			commonApi.showAlert("Please select organization");
			return;
		}
		
		if(item.mstart == undefined || item.start == undefined)
		{
			commonApi.showAlert("Please select your time period");
			return;
		}
		if(item.current!=true && ( item.mend == undefined  || item.end == undefined || item.mend == "" || item.end == 0))
		{
			commonApi.showAlert("Please select your time period");
			return;
		}
		if(item.des == undefined || item.des.trim().length == 0)
		{
			commonApi.showAlert("Please enter description");
			return;
			//return;
		}
		var d1 = this.getDateFromString(item.mstart,item.start);
								var d2 = new Date();
								if(item.current == undefined || item.current == false || item.current == 0)
								{
									d2 = this.getDateFromString(item.mend,item.end);
								}
								var month = this.monthDiff(d1,d2);
								if(month <= 0 )
								{
									commonApi.showAlert("Your time period not valid");
									return;
								}
		
		if(item.id == undefined)
		{
			item.id = 0;
			//return;
		}
		if(item.current == undefined)
		{
			item.current = 0;
			//return;
		}
		if(item.mend == undefined)
		{
			item.mend = "";
			//return;
		}
		if(item.current == true)
		{
			item.current = "1";
			item.mend = "";
			item.end = "0";
		}
		else {
			item.current = "0";
		}
		
		var data = new FormData();
			data.append('id', item.id);
			data.append('sgroup', item.sgroup);
          data.append('mend', item.mend);
          data.append('end', item.end);
          data.append('start', item.start);
          data.append('mstart', item.mstart);
          data.append('position', item.position);
          data.append('des', item.des);
          data.append('current', item.current);
          
          axios.post(commonApi.getAPIURL()+'?api=updateOrg',data)
		    .then(response => {	
		    	if(response.data.status == 1)
		    	{
		    		this.setState({show:false,item:{}});
		    		
		    			this.getOrgs();
		    		
		    		
		    		
		    	}
		    	
		    	//console.log(response.data);
		      
		      return response;
		    }).catch(error=> {
    
  });
   			
   		}
          
  	
  	cancel(e)
  	{
  		this.setState({show:false,item:{}});
  	}
  	
  	editOrg(it,e)
  	{
  		var item = Object.assign({},it);;
  		if(item.id_file > 0)
   		{
   			item.img = (<img src={item.file.link_file}/>);
   		}
   		else {
   			item.img = item.name.substring(0,1).toUpperCase();
   		}
   		
   		item.sgroup = item.id_sgroup;
   		item.current = item.current==0?false:true;
   		item.edit = true;
  		this.setState({show:true,item:item},()=>{this.refs.position.focus()});
  		
  	}
	removeOrg(it,e)
	{
		var data = new FormData();
			data.append('id', it.id);
			
          axios.post(commonApi.getAPIURL()+'?api=removeOrg',data)
		    .then(response => {	
		    	if(response.data.status == 1)
		    	{
		    		this.setState({show:false,item:{}});
		    		
		    			this.getOrgs();
		    		
		    		
		    		
		    	}
		    	
		    	//console.log(response.data);
		      
		      return response;
		    }).catch(error=> {
    
  });
	}
	
	render() {
		// if(this.state.terms == undefined){
			// return (
				// <div className="page_course_box profile_content_wrapper">
						// <div >
							// <div style={{color:"#545454"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width="20px" height="20px" /> Loading</div>
						// </div>
// 					
				// </div>
			// );
		// }
		
		
    return (
    	<div className={(this.state.my || this.state.orgArr.length > 0)&& this.state.loading == false ?"page_course_box profile_content_wrapper hide-el":"hide-el"}>
	    	<div className="title_box">
	    		<img src="/static/img/appimg/icon_circle_blue.png"/>
	    		<div className="title">
	    			Organizations / Extracurriculars
	    		</div>
	    	</div>
	    	{this.state.show?(<div className="edit_box">
				<div className="left_edit_box">
					<div className="image">	
						{this.state.item.img}
					</div>
				</div>
				<div className="right_edit_box">
					<div className="edit_item">
						<div className="title">Position <label className="checkbox-inline fright" ><input type="checkbox" value="" onClick={this.onCurrentClick.bind(this)} checked={this.state.item.current}/> Current Position</label></div>
						<div ><input ref="position" onChange={this.onPositionChange.bind(this)} className="input_text" type="text"  placeholder="" value={this.state.item.position}/></div>
						
						
					</div>
					<div className="edit_item">
						<div className="title">Organization</div>
						<div ><Select
								    value={this.state.item.sgroup}
								    onChange={this.onSelectSgroup.bind(this)}
								    placeholder="Start typing to find your organization..."
								    options={this.state.sgroupOps}
								    optionRenderer={this.optionRenderer}
								    clearable={false}
							    	searchable={true}
								/></div>
						
						
					</div>
					<div className="edit_item inline_block">
						<div className="title">Time Period</div>
						<div className="div_50" style={{paddingRight:"10px"}}>
							<div >Start Date</div>
							<div className="inline_block" >
								<div className="div_50" style={{paddingRight:"5px"}}>
									<Select
								    value={this.state.item.mstart}
								    onChange={this.onSelectMStart.bind(this)}
								    placeholder=""
								    options={this.state.mOps}
								    clearable={false}
							    	searchable={false}
									/>
								</div>
								<div className="div_50" >
									<Select
								    value={this.state.item.start}
								    onChange={this.onSelectStart.bind(this)}
								    placeholder=""
								    options={this.state.dateOptions}
								    clearable={false}
							    	searchable={false}
									/>
								</div>
							</div>
						</div>
						<div className="div_50" style={{paddingLeft:"10px"}}>
							<div >End Date</div>
							<div className="inline_block">
								<div className="div_50" style={{paddingRight:"5px"}}>
									<Select
								    value={this.state.item.mend}
								    onChange={this.onSelectMEnd.bind(this)}
								    placeholder=""
								    options={this.state.mOps}
								    clearable={false}
							    	searchable={false}
									/>
								</div>
								<div className="div_50"  >
									<Select
								    value={this.state.item.end}
								    onChange={this.onSelectEnd.bind(this)}
								    placeholder=""
								    options={this.state.dateOptions}
								    clearable={false}
							    	searchable={false}
									/>
								</div>
							</div>
						</div>
						
					</div>
					
					
					<div className="edit_item">
						<div className="title">Description</div>
						<div >
							<Textarea placeholder=""  name="content" onChange={this.handleTxtChange.bind(this)} value={this.state.item.des}/>
						</div>
						
						
					</div>
					
					<div className="edit_item">
						<div className="title"></div>
						<a onClick={this.save.bind(this)} className="btn_v btn_confirm fright">Save</a>
						<a onClick={this.cancel.bind(this)} style={{marginRight:"10px"}} className="btn_v btn_cancel fright">Cancel</a>
						
					</div>
				</div>
			</div>):(<div className={this.state.my?"add_box clickable":"hide-el"} onClick={this.addClick.bind(this)}>
				<div className="left_add_box">
					<img src="/static/img/appimg/icon_add_black.png"/>
				</div>
				<div className="right_add_box">
					<div className="title">Add Organizations/ Extracurriculars</div>
					<div className="des"><img src="/static/img/appimg/icon_i.png"/> you can find an example below</div>
				</div>
			</div>)}
			{this.state.loading?(<div style={{marginTop:"10px"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width={20} height={20} /></div>):(<div>
				{this.state.orgArr.length == 0?(<div  className="item_box op07">
				<div className="left_item_box">
					<div className="image">	
						Y
					</div>
				</div>
				<div className="right_item_box">
					<div className="title">Analyst </div>
					<div className="des">Young Investors Club</div>
					<div className="des">Sep 2012 - Present</div>
					
					
					
					
				</div>
			</div>):"" }
			
			{this.state.orgArr}
			</div>)}
			

			
		</div>
      
    )
  }
}

export default ProfileGroup;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/profile/profile_group.js
 **/